import { Col } from 'react-bootstrap';

const InfoFieldRow = ({ name, value, colSizes}) => {
    var getVarValue = function (value, params) {
        if (typeof value === 'function') {
            return value(params);
        }
        else {
            return value;
        }
    };
    return (
        <div className="info-field-row" key={name + value}>
            <Col 
                xl={colSizes.label.xl ? colSizes.label.xl : null} 
                lg={colSizes.label.lg ? colSizes.label.lg : null} 
                md={colSizes.label.md ? colSizes.label.md : null} 
                sm={colSizes.label.sm ? colSizes.label.sm : null}  
                xs={colSizes.label.xs ? colSizes.label.xs : null}  
            >
                <p className="name w-auto" >{name}</p>
            </Col>
            <Col lg={7}>
                <p className="value w-auto" >{getVarValue(value)}</p>
            </Col>
            
        </div>
    );
}

export default InfoFieldRow; 